import Default from '@pages/authentication/verify-account'

export default {
  path: 'verify-account',
  name: 'verify-account',
  components: {
    default: Default,
  },
}
